'use client';

import { FeedProvider } from './FeedContext';
import MainContent from './main-content';
import RightBar from './right-bar';
import SideBar from './side-bar';

const Feed: React.FC<any> = () => {
  return (
    <FeedProvider>
      <div className="relative flex justify-between p-10 lg:p-5 sm:flex-col sm:gap-10">
        <SideBar />
        <MainContent />
        <RightBar />
      </div>
    </FeedProvider>
  );
};

export default Feed;
